import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { createPost } from "@/lib/admin-content.functions";
import { postInputSchema } from "@/lib/admin-content.schemas";
import { slugify } from "@/lib/slugify";
import { PostForm } from "@/components/admin/PostForm";

export const Route = createFileRoute("/_authenticated/_admin/admin/blog/new")({
  component: NewBlogPage,
});

function NewBlogPage() {
  const navigate = useNavigate();
  const submit = useServerFn(createPost);
  const qc = useQueryClient();
  const [submitting, setSubmitting] = useState(false);

  return (
    <PostForm
      title="Neuer Blogpost"
      submitting={submitting}
      onSubmit={async (values) => {
        const parsed = postInputSchema.safeParse({ ...values, type: "blog", slug: values.slug || slugify(values.title) });
        if (!parsed.success) {
          toast.error("Eingabe ungültig", { description: parsed.error.issues.map(i => i.message).join("; ") });
          return;
        }
        setSubmitting(true);
        try {
          const res = await submit({ data: parsed.data });
          toast.success("Blogpost angelegt", { description: `Slug: ${res.slug}` });
          qc.invalidateQueries({ queryKey: ["admin-content"] });
          navigate({ to: "/admin" });
        } catch (e: any) {
          toast.error("Speichern fehlgeschlagen", { description: e?.message ?? String(e) });
        } finally {
          setSubmitting(false);
        }
      }}
    />
  );
}
